import { render, staticRenderFns } from "./LoadSpinner.vue?vue&type=template&id=2950193b"
import script from "./LoadSpinner.vue?vue&type=script&lang=js"
export * from "./LoadSpinner.vue?vue&type=script&lang=js"
import style0 from "./LoadSpinner.vue?vue&type=style&index=0&id=2950193b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports